import type { ItemDoFunilNoCrm, Oportunidade, RankingUtm } from "@base/contracts";
import { Botao, Tabela } from "@base/ui";
import { descreverIntervalo, type Intervalo } from "../../../shared/periodo/periodos";
import { RankingDeUtm } from "./ranking-de-utm";
import { COLUNAS_DA_OPORTUNIDADE } from "./colunas-da-oportunidade";

const FILTROS: readonly { etapa: ItemDoFunilNoCrm; rotulo: string }[] = [
  { etapa: "crm", rotulo: "Leads" },
  { etapa: "mql", rotulo: "MQL" },
  { etapa: "agendado", rotulo: "Agendamentos" },
  { etapa: "consulta", rotulo: "Comparecimentos" },
  { etapa: "venda", rotulo: "Vendas" },
];

export function ListaDeOportunidades({
  etapa,
  aoMudarEtapa,
  dados,
  ranking,
  total,
  carregando,
  periodo,
}: {
  readonly etapa: ItemDoFunilNoCrm;
  readonly aoMudarEtapa: (etapa: ItemDoFunilNoCrm) => void;
  readonly dados: readonly Oportunidade[];
  readonly ranking: readonly RankingUtm[];
  readonly total: number;
  readonly carregando: boolean;
  readonly periodo: Intervalo;
}) {
  return (
    <section aria-labelledby="titulo-oportunidades" className="flex flex-col gap-bloco">
      <div className="flex flex-col gap-1">
        <h2 id="titulo-oportunidades" className="text-xl font-normal tracking-tight">
          Oportunidades
        </h2>
        <p className="text-sm text-muted-foreground">
          Quem chegou à etapa em {descreverIntervalo(periodo)}, com os mesmos filtros do topo. Contato não entra
          nesta lista.
        </p>
      </div>

      <div className="grid items-stretch gap-bloco lg:grid-cols-[minmax(0,1fr)_minmax(26rem,1.2fr)]">
        <div className="flex h-[28rem] flex-col overflow-hidden rounded-3xl bg-card shadow-sm ring-1 ring-border/70">
          <div role="tablist" aria-label="Etapa do funil" className="flex shrink-0 flex-wrap gap-2 border-b px-4 py-3">
            {FILTROS.map((filtro) => (
              <Botao
                key={filtro.etapa}
                variante={filtro.etapa === etapa ? "primario" : "fantasma"}
                tamanho="pequeno"
                role="tab"
                aria-selected={filtro.etapa === etapa}
                onClick={() => aoMudarEtapa(filtro.etapa)}
              >
                {filtro.rotulo}
              </Botao>
            ))}
          </div>

          <div className="min-h-0 flex-1 overflow-auto">
            {carregando && dados.length === 0 ? (
              <p className="px-5 py-8 text-sm text-muted-foreground">Carregando oportunidades…</p>
            ) : dados.length === 0 ? (
              <p className="px-5 py-8 text-sm text-muted-foreground">
                Nenhuma oportunidade nesta etapa no período.
              </p>
            ) : (
              <Tabela
                colunas={COLUNAS_DA_OPORTUNIDADE}
                itens={dados}
                chaveDe={(item) => String(item.leadId)}
                legenda="Oportunidades"
              />
            )}
          </div>
          {dados.length > 0 ? (
            <p className="shrink-0 border-t border-border/70 px-5 py-3 text-xs text-muted-foreground">
              {total > dados.length
                ? `Mostrando ${dados.length} de ${total}.`
                : `${total} ${total === 1 ? "oportunidade" : "oportunidades"}`}
            </p>
          ) : null}
        </div>
        {carregando && dados.length === 0 ? null : <RankingDeUtm ranking={ranking} />}
      </div>
    </section>
  );
}

